import { useContext, useState,MouseEvent } from 'react';
import { Modal, Input, Button, Loader, Placeholder } from 'rsuite';
import { toast, ToastContainer } from 'react-toastify';
import { Application } from '../../../common.interface';
import axios from 'axios';
import { UserContext } from '../../../context/userContext';
import useApplication from '../../../hooks/useApplication';
import { sendMail } from '../../../services/MailService';


const CustomApplicationModal = ({open,handleOpen,data,setData}:{open:boolean,handleOpen:any,data:Application,setData:any}) => {
  type Approver={
    status:string,
    approverId?: string,
    approverName?: string,
}
  
  const {updateApplication} = useApplication();
  const {user} = useContext(UserContext);
    const {_id,approver,name,address,email,purpose,country,duration,amount,otherSource,experience,fundReason,phoneNumber} = data;   
    
    const reset = () => {
        setData(null);
    }

    

    const handleUpdate = async(e:MouseEvent<HTMLButtonElement>) => {
      e.preventDefault()
      const newdata:{approver:Approver} = {
            "approver": {
            "approverId":user!.id,
            "approverName":user!.email,
           "status":"approved"
        }
      }
        
      try {
        const response = await axios.put(`${process.env.REACT_APP_BASE_URL}/application/update/${_id}`,newdata,{headers:{Authorization:'Bearer '+user.accessToken}});
        if(response.status ===200){
          updateApplication(response.data.data)
          handleOpen()
          reset();
          toast.success("Application approved,Mail Applicant", {
              position: toast.POSITION.TOP_CENTER
            });
            sendMail(email,name,'Congratulation You Got Funding')
          }
          else{
              toast.error("Couldn't approve application !", {
                  position: toast.POSITION.TOP_CENTER
                });
          }
          
      } catch (error) {
        toast.error(`${(error as any).message}`, {
          position: toast.POSITION.TOP_CENTER
        });
        // console.log('MyError',error)
      }
    }
    const handleDecline = async(e:MouseEvent<HTMLButtonElement>) => {
      // console.log('user token',user.accessToken)
      e.preventDefault()
      const newdata:{approver:Approver} = {
        "approver": {
        "approverId":user.id,
        "approverName":user.email,
       "status":"rejected"
    }
  }
    
  try {
    const response = await axios.put(`${process.env.REACT_APP_BASE_URL}/application/update/${_id}`,newdata,{headers:{Authorization:'Bearer '+user.accessToken}});
    if(response.status ===200){
      updateApplication(response.data.data)
      handleOpen()
      reset();
      toast.success("Application rejected,Mail Applicant", {
          position: toast.POSITION.TOP_CENTER
        });
      sendMail(email,name,'TMP Could\'t Approve Your Application')
      }
      else{
          toast.error("Couldn't reject application !", {
              position: toast.POSITION.TOP_CENTER
            });
      }
      
  } catch (error) {
    toast.error(`${(error as any).message}`, {
      position: toast.POSITION.TOP_CENTER
    });
    // console.log('MyError',error)
  }
    }

  return (
    <>
      <div>
        <Modal
            open={open}
            onClose={handleOpen}  
        >
            <Modal.Header>
            <Modal.Title ><p className='font-semibold'>Review Application</p> </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p className='mb-2'>This application is <span className='font-bold' >{approver.status}</span> </p>
            <form >
                <label htmlFor="name">Name</label>
                <Input value={name} id='name' type='text' name='name' readOnly className='mb-2'/>
                <label htmlFor="email">Email</label>
                <Input value={email} id='email' type='email'  name='email' readOnly className='mb-2'/>
                
               <label htmlFor="phoneNumber">Phone Number</label>
                <Input value={phoneNumber} id='phoneNumber' type='text'  name='phoneNumber' readOnly className='mb-2'/>
                <div className='flex justify-between'>
                  <div className='w-1/2'>
                    <label htmlFor="address">Address</label>
                    <Input value={address} id='address' type='text'  name='address' readOnly className='mb-2'/>
                  </div> 
                  <div className='w-1/2'>
                    <label htmlFor="country">Country</label>
                    <Input value={country} id='country' type='text'  name='country' readOnly className='mb-2'/>
                  </div>  
                </div>
                <label htmlFor="experience">Experience</label>
                <Input as="textarea" id='experience' rows={3}  value={experience} type='textArea'  name='experience' readOnly className='mb-2'/>

                 <div className='flex justify-between'>
                   <div className='w-1/2'>
                      <label htmlFor="amount">Amount</label>
                      <Input value={amount} id='amount' type='number'  name='amount' readOnly className='mb-2'/>                 
                    </div>
                    <div className='w-1/2'>
                      <label htmlFor="duration">Duration</label>
                      <Input id='duration' value={duration} type='text'  name='duration' readOnly className='mb-2'/>                               
                    </div>
                 </div>

                <label htmlFor="purpose">Purpose Of Mission</label>
                <Input as="textarea" id='purpose' rows={3} value={purpose} type='text'  name='purpose' readOnly className='mb-2'/> 
                <label htmlFor="fundReason">Reason For Funds</label>
                <Input as="textarea" id='fundReason' rows={3} value={fundReason} type='text'  name='fundReason' readOnly className='mb-2'/>                
                <label htmlFor="otherSource">Other Source</label>
                <Input as="textarea" id='otherSource' rows={3} value={otherSource} type='text'  name='otherSource' readOnly className='mb-2'/>
            </form>
            </Modal.Body>
            <Modal.Footer>
            <Button id='approveButton' onClick={handleUpdate} appearance={approver.status==="approved"?"default":"primary"} color="orange">
                Approve
            </Button>
            <Button id='rejectButton' onClick={handleDecline} appearance="ghost" color="red">
                Decline
            </Button>
            </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};

export default CustomApplicationModal;